import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import {
  UPDATE_WARRANTY_API_URL,
  WARRANTY_APPROVE,
  WARRANTY_DETAILS,
  WARRANTY_LIST,
  WARRANTY_UPDATE_STATUS,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Warranty List ---------------- */
export const GetWarrantyList = createAsyncThunk(
  "get-warranty-list/admin",
  async (reqData) => {
    try {
      const { status, page, limit, search } = reqData;
      const response = await getApi(
        `${WARRANTY_LIST}?status=${status}&page=${page}&limit=${limit}&search=${search}`
      );
      return response;
    } catch (error) {
      console.log("Error GetWarrantyList API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Approve Warranty ---------------- */
export const ApproveWarranty = createAsyncThunk(
  "approve-warranty/admin",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await postApi(WARRANTY_UPDATE_STATUS, reqData);

      // Check if the response contains an error status code
      if (response?.data?.statusCode >= 400) {
        console.log("Error response:", response.data);
        return rejectWithValue(response.data);
      }

      return response;
    } catch (error) {
      console.log("Error ApproveWarranty API", error);
      Alertify.error(error.message);
      return rejectWithValue(error);
    }
  }
);

/*---------------- Warranty Details ---------------- */
export const GetWarrantyDetails = createAsyncThunk(
  "get-warranty-details/admin",
  async (reqData) => {
    try {
      const response = await postApi(WARRANTY_DETAILS, reqData);
      return response;
    } catch (error) {
      console.log("Error GetWarrantyDetails API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

// --------------------------------------update warranty details-------------------

// warranty-action.ts
export const UpdateWarrantyDetails = createAsyncThunk(
  "warranty/update-customer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postApi(UPDATE_WARRANTY_API_URL, payload);
      Alertify.success("Warranty details updated successfully");
      return response;
    } catch (error) {
      Alertify.error("Failed to update warranty");
      return rejectWithValue(error.message);
    }
  }
);

/*---------------- Get PPF details while approve ---------------- */
export const GetPpfDetailsWhileApprove = createAsyncThunk(
  "get-ppf-details-while-approve/admin",
  async (reqData) => {
    try {
      const response = await postApi(WARRANTY_APPROVE, reqData);
      return response;
    } catch (error) {
      console.log("Error GetPpfDetails API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
